import React, { useEffect, useState } from "react";
import {
  DatePicker,
  Checkbox,
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Card,
  message,
  Radio,
  Space,
} from "antd";
import PageHeading from "../../../../components/common/PageHeading";
import { repeats, creationStyle } from "../../../../utils/Util";
import TextArea from "antd/es/input/TextArea";
import BillingInformation from "./Components/BillingInformation";
import Notes from "../../../../components/common/Notes";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";

import { getDocs, collection, doc, query, where } from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import { useForm } from "antd/lib/form/Form";
import { createNewRecurringWorkOrder } from "./NewRecurringWorkOrderFirebase";
import { useNavigate } from "react-router-dom";

function NewRecurringWorkOrders() {
  // const options = []
  const [options, setOptions] = useState([
    { value: "January", check: false },
    { value: "February", check: false },
    { value: "March", check: false },
    { value: "April", check: false },
    { value: "May", check: false },
    { value: "June", check: false },
    { value: "July", check: false },
    { value: "August", check: false },
    { value: "September", check: false },
    { value: "October", check: false },
    { value: "November", check: false },
    { value: "December", check: false },
  ]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [properties, setProperties] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [propertySelect, setPropertySelect] = useState("");
  const [totalMonths, setTotalMonths] = useState("");
  const [isWait, setIsWait] = useState(false);
  const [accounts, setAccounts] = useState([
    { id: 1, account: "", statementDescription: "", amount: "" },
  ]);
  const [notes, setNotes] = useState([]);

  const [form] = useForm();

  console.log(options);
  const navigate = useNavigate();
  const onChange = (e) => {
    console.log(e.target.value);
    setOptions(
      [...options].map((object) => {
        if (object.value === e.target.value) {
          return {
            ...object,
            check: e.target.checked,
          };
        }
        return { ...object };
      })
    );
    setTotalMonths(options);
  };
  const selectAll = () => {
    setOptions(
      [...options].map((object) => {
        return {
          ...object,
          check: true,
        };
      })
    );
    console.log(options);
  };

  const selectNone = () => {
    setOptions(
      [...options].map((object) => {
        return {
          ...object,
          check: false,
        };
      })
    );
    console.log(options);
  };

  const [files, setFiles] = useState([]);

  const onFinish = (values) => {
    setIsWait(true);
    const filterOptions = options.filter((option) => option.check);

    const filteredNotes = notes.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    try {
      createNewRecurringWorkOrder(
        values,
        filterOptions,
        accounts,
        companyName,
        filteredNotes,
        files
      ).then(() => {
        message.success("New Recuriing work order Created SuccessFully!", 2);
        navigate("/maintenance/recurring-work-orders");
      });
    } catch (err) {
      message.error(err.message);
      setIsWait(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("failed");
    console.log(errorInfo);
    setIsWait(false);
  };

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const propertiesRef = collection(companyDocRef, "properties");
        const querySnapshot = await getDocs(propertiesRef);

        console.log("...", querySnapshot);

        const fetchedData = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: doc?.data()?.propertyNameAddress?.propertyName,
          ...doc.data(),
        }));

        setProperties(fetchedData);
        console.log(fetchedData, "fetching..");
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchProperties();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    const fetchVendors = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const vendorsRef = collection(companyDocRef, "vendors");
        const querySnapshot = await getDocs(vendorsRef);

        console.log("...", querySnapshot);

        const fetchedVendors = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: `${doc?.data()?.vendorInfo?.firstName} ${
            doc?.data()?.vendorInfo?.lastName
          }`,
          ...doc.data(),
        }));

        setVendors(fetchedVendors);
        console.log(fetchedVendors, "fetching vendor");
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    console.log("useeffect");

    fetchVendors();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched]);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    const fetchUsers = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const userRef = collection(companyDocRef, "users");
        const querySnapshot = await getDocs(userRef);

        console.log("...", querySnapshot);

        const fetchedUsers = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: `${doc?.data()?.profile?.firstName} ${
            doc?.data()?.profile?.lastName
          }`
        }));

        setUsers(fetchedUsers);
        console.log(fetchedUsers, "fetching vendor");
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    console.log("useeffect");

    fetchUsers();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched]);

  const propertyArr = [];
  properties?.forEach((element) => {
    propertyArr.push(element.value);
    console.log(element, "element");
  });
  const vendorArr = [];
  vendors?.forEach((element) => {
    vendorArr.push(element.value);
    console.log(element, "element");
  });

  const handleCancel = () => {
    navigate("maintenance/recurring-work-orders");
  };

  const [propertyData, setPropertyData] = useState({});

  const setPropertyDetails = (propertyId) => {
    setPropertySelect(propertyId);
    const propertyData = properties.find((item) => item.id === propertyId);
    setPropertyData(propertyData);
  };

  const [vendorData, setVendorData] = useState({});
  const [vendorSelect, setVendorSelect] = useState("");

  const setVendorDetails = (vendorId) => {
    setVendorSelect(vendorId);
    const venData = vendors.find((item) => item.id === vendorId);
    setVendorData(venData);
  };

  console.log("propertyData", vendorData);

  return (
    <>
      <PageHeading heading="New Recurring Work Orders" />

      <Form
        name="basic"
        labelCol={{ span: 7 }}
        initialValues={{ remember: true }}
        autoComplete="off"
        className="form-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row>
          <Col span={24}>
            {/* RECURRANCE INFORMATION */}

            <Card title="Recurrance Information" bordered={false}>
              <Form.Item
                name="startDate"
                label="Start Date"
                rules={[
                  {
                    required: true,
                    message: "Please select Unit!",
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item label="End On" name="endDate">
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item label="Repeats" name="repeat">
                <Select options={repeats} />
              </Form.Item>

              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Please select Unit!",
                  },
                ]}
                name="postDay"
                label="Post Day"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Select Month(s)"
                name="selectMonth"
                initialValue={[]}
              >
                <Button type="link" style={{ padding: 0 }} onClick={selectAll}>
                  All
                </Button>
                <Button type="link" onClick={selectNone}>
                  None
                </Button>
                <br />
                <div>
                  <Row style={{ marginTop: 8 }}>
                    {options.slice(0, 4).map((month) => (
                      <Col key={month} span={6}>
                        <Checkbox
                          value={month.value}
                          onChange={onChange}
                          checked={month.check}
                        >
                          {month.value}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                  <Row style={{ marginTop: 8 }}>
                    {options.slice(4, 8).map((month) => (
                      <Col key={month} span={6}>
                        <Checkbox
                          value={month.value}
                          onChange={onChange}
                          checked={month.check}
                        >
                          {month.value}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                  <Row style={{ marginTop: 8 }}>
                    {options.slice(8).map((month) => (
                      <Col key={month} span={6}>
                        <Checkbox
                          value={month.value}
                          onChange={onChange}
                          checked={month.check}
                        >
                          {month.value}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Form.Item>
            </Card>

            <br />

            <Card title="Details" bordered={false}>
              <h4 style={{ fontSize: 13, marginBottom: 20 }}>
                Property Information
              </h4>

              <Form.Item
                name="properties"
                label="Properties"
                rules={[
                  {
                    required: true,
                    message: "Please select Unit!",
                  },
                ]}
              >
                <Select
                  showSearch
                  options={properties}
                  onChange={(value) => setPropertyDetails(value)}
                />
              </Form.Item>

              <Form.Item name="unit" label="Unit">
                <Select
                  options={[{ value: propertyData?.label }]}
                  disabled={propertySelect ? false : true}
                />
              </Form.Item>

              <Form.Item name="creationStyle" label="Creation Style">
                <Select
                  options={creationStyle}
                  defaultValue={creationStyle[0]}
                />
              </Form.Item>

              {propertySelect ? (
                <Form.Item label="Property Information">
                  <p>{propertyData?.propertyNameAddress?.propertyName}</p>
                </Form.Item>
              ) : null}

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>
                Work Order Information
              </h4>

              <Form.Item name="description" label="Description">
                <TextArea rows={3} />
              </Form.Item>

              <Form.Item name="vendorInstructions" label="Vendor Instructions">
                <TextArea rows={3} />
              </Form.Item>

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>
                Vendor Information
              </h4>

              <Form.Item name="vendor" label="Vendor">
                <Select
                  showSearch
                  options={vendors}
                  onChange={(value) => setVendorDetails(value)}
                />
              </Form.Item>

              {vendorSelect ? (
                <>
                  <Form.Item label="Phone Numbers">
                    <p>
                      Phone -{" "}
                      <span className="onclick-text">
                        {vendorData?.contact?.phoneNumbers.length > 0
                          ? vendorData?.contact.phoneNumbers[0].phoneNumber
                          : null}
                      </span>
                    </p>
                  </Form.Item>
                  <Form.Item label="Emails">
                    <p>
                      {vendorData?.contact?.emails?.length > 0
                        ? vendorData?.contact?.emails[0].email
                        : null}
                    </p>
                  </Form.Item>
                  <Form.Item label="Address">
                    <p>
                      {vendorData?.contact?.addresses.length > 0
                        ? vendorData?.contact.addresses[0].addressLine1
                        : null}
                    </p>
                  </Form.Item>
                  <Form.Item
                    name="adjustmentPercent"
                    label="Adjustment Percent"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item label="Adjustment Type" name="adjustmentType">
                    <Radio.Group>
                      <Space direction="vertical">
                        <Radio value="discount">Discount</Radio>
                        <Radio value="markup">Markup</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </>
              ) : null}

              <Form.Item name="assignTo" label="Assign To">
                <Select options={users} disabled={propertySelect ? false : true} />
              </Form.Item>

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>
                Billing Information
              </h4>

              <BillingInformation
                accounts={accounts}
                setAccounts={setAccounts}
              />
            </Card>
            <br />
            <Col span={24}>
              {companyName ? (
                <Notes
                  notesForCollection="recurringWorkOrders"
                  notesForCollectionId=""
                  companyName={companyName}
                  notes={notes}
                  setNotes={setNotes}
                />
              ) : null}
            </Col>
            <br />
            <Col span={24}>
              <AttachmentsUpload setFiles={setFiles} />
            </Col>

            <div
              className="form-action page-actions-container"
              style={{ marginTop: 22, flexDirection: "row-reverse" }}
            >
              <Row gutter={16}>
                <Col>
                  <Button type="primary" htmlType="submit" disabled={isWait}>
                    {isWait ? "Please wait..." : "Save"}
                  </Button>
                </Col>
                <Col>
                  <Button onClick={handleCancel}>Cancel</Button>
                </Col>
              </Row>
            </div>

            <br />
          </Col>
        </Row>
      </Form>

      <div className="RightSidebar"></div>
    </>
  );
}

export default NewRecurringWorkOrders;
